import instance from "./auth";

export const getAllData = async (params) => {
    const {data} = await instance.get("/delegates/all", {
        params,
    });
    return data;
}

export const getAll = async (params) => {
    const {data} = await instance.get("/delegates", {
        params,
    });
    return data;
}

export const createGetById = (id) => {
    const getById = async (params) => {
        const {data} = await instance.get(`/delegates/${id}/missions`, {
            params,
        });
        return data;
    }

    return getById;
}


